var exports = {
  "In": "TextualAttachmentPreview.module__textualPreview___Ui1RLV",
  "KR": "TextualAttachmentPreview.module__previewSurface___Ui1RLV",
  "cA": "TextualAttachmentPreview.module__previewActions___Ui1RLV",
  "wL": "TextualAttachmentPreview.module__previewActionsVisible___Ui1RLV",
  "VA": "TextualAttachmentPreview.module__previewActionButton___Ui1RLV" + " " + __webpack_require__(180357)["AS"],
  "nJ": "TextualAttachmentPreview.module__copyIcon___Ui1RLV",
  "fs": "TextualAttachmentPreview.module__inlinePreviewSurface___Ui1RLV",
  "vd": "TextualAttachmentPreview.module__previewViewport___Ui1RLV",
  "uL": "TextualAttachmentPreview.module__previewViewportCollapsed___Ui1RLV",
  "q4": "TextualAttachmentPreview.module__previewViewportExpanded___Ui1RLV",
  "Nv": "TextualAttachmentPreview.module__csvTableViewport___Ui1RLV",
  "rV": "TextualAttachmentPreview.module__csvTableMarkup___Ui1RLV",
  "uT": "TextualAttachmentPreview.module__previewCode___Ui1RLV",
  "O9": "TextualAttachmentPreview.module__previewCodeWrap___Ui1RLV",
  "VP": "TextualAttachmentPreview.module__previewError___Ui1RLV",
  "Ml": "TextualAttachmentPreview.module__loadingState___Ui1RLV",
  "qr": "TextualAttachmentPreview.module__footer___Ui1RLV",
  "X1": "TextualAttachmentPreview.module__expandButton___Ui1RLV" + " " + __webpack_require__(180357)["AS"],
  "eO": "TextualAttachmentPreview.module__expandIcon___Ui1RLV",
  "t2": "TextualAttachmentPreview.module__expandIconExpanded___Ui1RLV",
  "qt": "TextualAttachmentPreview.module__fileSection___Ui1RLV",
  "gM": "TextualAttachmentPreview.module__fileMeta___Ui1RLV",
  "Md": "TextualAttachmentPreview.module__fileName___Ui1RLV",
  "Ov": "TextualAttachmentPreview.module__fileSize___Ui1RLV",
  "zt": "TextualAttachmentPreview.module__footerActions___Ui1RLV",
  "uH": "TextualAttachmentPreview.module__controlButton___Ui1RLV" + " " + __webpack_require__(180357)["AS"],
  "RJ": "TextualAttachmentPreview.module__languagePositioner___Ui1RLV",
  "tP": "TextualAttachmentPreview.module__languagePopup___Ui1RLV",
  "Nl": "TextualAttachmentPreview.module__languageSearchWrap___Ui1RLV",
  "nb": "TextualAttachmentPreview.module__languageSearchInput___Ui1RLV",
  "qm": "TextualAttachmentPreview.module__languageEmpty___Ui1RLV",
  "xl": "TextualAttachmentPreview.module__languageList___Ui1RLV",
  "O6": "TextualAttachmentPreview.module__languageItem___Ui1RLV",
  "d6": "TextualAttachmentPreview.module__languageItemHighlighted___Ui1RLV",
  "J6": "TextualAttachmentPreview.module__languageItemSelected___Ui1RLV",
  "xu": "TextualAttachmentPreview.module__languageItemIndicator___Ui1RLV",
  "lh": "TextualAttachmentPreview.module__languageOptionContent___Ui1RLV",
  "XO": "TextualAttachmentPreview.module__languageOptionCode___Ui1RLV",
  "_s": "TextualAttachmentPreview.module__languageOptionCanonical___Ui1RLV",
  "CR": "TextualAttachmentPreview.module__modalRoot___Ui1RLV",
  "Ij": "TextualAttachmentPreview.module__modalLayout___Ui1RLV",
  "S3": "TextualAttachmentPreview.module__modalBody___Ui1RLV",
  "fn": "TextualAttachmentPreview.module__modalPreviewSurface___Ui1RLV",
  "CM": "TextualAttachmentPreview.module__previewViewportFill___Ui1RLV",
  "v6": "TextualAttachmentPreview.module__previewCodeFill___Ui1RLV",
};

module.exports = exports;
